import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { urls } from '..';
import { iconSportCssClass } from '../data/utils/iconSportCssClass';
import { useFavorites } from './FavoritesProvider';
import { useIsDateSection } from './IsDateSectionProvider';
import { XRouterNavigateContext } from './seo/xrouter/XRouterNavigateContext';
import useIsLiveSection from './useIsLiveSection';
import CalendarDropdownButton from '../live/calendar/CalendarDropdownButton';
import OverlayWrapper from './OverlayWrapper';
import RouletteButton from './roulette/RouletteButton';
import { getItemsToRender } from '../utils/getItemsToRender';
import { removeMultipleSlashes } from '../data/sport-utils';
import LiveStreamingDropdownButton from '../live/LiveStreamingDropdownButton';
import { getLabel } from '../data/labels';
import RaceSportButton from './race-sport/RaceSportButton';
import { getConfiguration } from '../data/utils/configuration';
import BottomModal from './BottomModal';

function FavoritesUrl(props) {
    const xrouterNavigateContext = useContext(XRouterNavigateContext);
    const favorites = useFavorites();

    function handleClick(e) {
        e.stopPropagation();
        const url = props.isLiveSection ? `${urls.base}/${urls.live.base}/preferiti` : `${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/preferiti`;
        xrouterNavigateContext.navigate(url);
    }

    return (
        <div className="shrink-0 h-[50px] grid grid-cols-12 items-center border-y border-y-cs7" onClick={handleClick}>
            <div className="col-start-1 col-end-3 justify-self-center inline-block w-[24px] h-[24px] bi-star-fill text-cs5"></div>
            <div className="col-start-3 col-end-11 font-medium text-sm text-cs-3">{getLabel('general.favorites')}</div>
            <div className="sports-events-count col-start-11 col-end-13">
                <div className="min-h-[24px] min-w-[28px] w-fit px-1 mx-auto flex items-center justify-center bg-cs4 rounded-md">
                    <span className="leading-[.6rem] font-medium text-xxs text-cs1">{Object.keys(favorites).length}</span>
                </div>
            </div>
        </div>
    );
}
export default function SportsDropdown(props) {
    const xrouterNavigateContext = useContext(XRouterNavigateContext);
    const params = useParams();
    const pathname = useLocation().pathname;
    const isDateSection = useIsDateSection();
    const isLiveSection = useIsLiveSection();
    const conf = getConfiguration();

    function getUrl(sport) {
        let url = null, replace = false;
        if (isLiveSection) {
            url = `${urls.base}/${urls.live.base}/${sport.id}`;
        } else if (isDateSection) {
            const prematchBase = `${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${urls.prematch.allMatches}`;
            if (pathname.startsWith(removeMultipleSlashes(prematchBase))) {
                url = removeMultipleSlashes(`${prematchBase}/${params.date}/${sport.id}/${sport.aggregata}`);
                replace = true;
            } else {
                url = removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${params.date}/${sport.id}/${sport.aggregata}`);
            }
        } else {
            url = removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/${sport.id}`);
        }
        return [url, replace];
    }

    function handleSportClick(e, sport) {
        e.stopPropagation();
        props.toggle(e);
        if (props.changeSport) {
            props.changeSport(sport.id);
            return;
        }
        const [url, replace] = getUrl(sport);
        xrouterNavigateContext.navigate(url, { data: sport, replace });
    }

    const items = getItemsToRender ? getItemsToRender(props.sports) : props.sports;

    const dropdownContent = (
        <>
            {!conf.iwh &&
                <FavoritesUrl isLiveSection={isLiveSection} />
            }

            {(items?.length === 0 || !items?.find((item) => item?.typ?.includes('ROULETTE'))) &&
                <RaceSportButton />
            }

            {items.map((item, i) => {
                if (item?.typ?.includes('ROULETTE')) {
                    return (
                        <React.Fragment key={`roul-${i}`}>
                            <RaceSportButton />
                            <RouletteButton conf={item} />
                        </React.Fragment>
                    );
                }

                const sport = item;
                const isSelected = props.selected?.id === sport.id;
                const sportIcon = iconSportCssClass(sport.id, sport.iconClass);

                return (
                    <div
                        key={sport.id}
                        className={`relative shrink-0 h-[50px] grid grid-cols-12 items-center border-y border-y-cs7 ${isSelected ? 'bg-cs12' : ''}`}
                        onClick={(e) => handleSportClick(e, sport)}
                    >
                        <div className={"xs-sport-icon col-start-1 col-end-3 justify-self-center inline-block w-[24px] h-[24px] " + sportIcon}></div>
                        <div className="col-start-3 col-end-11 font-medium text-sm text-cs-3">{sport.descrizione || sport.desc}</div>

                        <div className="sports-events-count col-start-11 col-end-13">
                            {sport?.eventsCount > 0 &&
                                <div className="min-h-[24px] min-w-[28px] w-fit px-1 mx-auto flex items-center justify-center bg-cs4 rounded-md">
                                    <span className="leading-[.6rem] font-medium text-xxs text-cs1">{sport.eventsCount}</span>
                                </div>
                            }
                        </div>

                        {isSelected &&
                            <span className="absolute left-0 top-2 bottom-2 w-[4px] bg-cs13 rounded-tr-md rounded-br-md"></span>
                        }
                    </div>
                );
            })}

            {props.showCalendar && <CalendarDropdownButton />}
            {props.showCalendar && <LiveStreamingDropdownButton />}
        </>
    );


    // ModalBottom
    if (conf.iwh) {
        return (
            <BottomModal
                isOpen={true}
                onClose={props.toggle}
                title={getLabel('general.choose_sport')}
                id="xs-sports-modal"
            >
                {dropdownContent}
            </BottomModal>
        );
    }

    // Default 
    return (
        <OverlayWrapper id="xs-sports-overlay">
            <div className="xs_sportsDropdown z-30 absolute container top-0 left-0 right-0 bottom-0">
                <div className="h-full overflow-y-auto flex flex-col bg-cs1">
                    <div className="choose-sport-dropdown-item z-20 sticky top-0 shrink-0 h-[50px] grid grid-cols-12 items-center border-b border-b-cs7 bg-cs1">
                        <div className="col-start-1 col-end-3 justify-self-center inline-block" onClick={props.toggle}>
                            <i className="bi-x-lg font-medium text-lg text-cs-3"></i>
                        </div>
                        <div className="col-start-3 col-end-11 font-medium text-lg text-cs-3">
                            {getLabel('general.choose_sport')}
                        </div>
                        <div className="col-start-11 col-end-13 justify-self-center font-normal text-sm text-cs-3"></div>
                    </div>
                    {dropdownContent}
                </div>
            </div>
        </OverlayWrapper>
    );
}
